(function(b){function c(){}for(var d="assert,count,debug,dir,dirxml,error,exception,group,groupCollapsed,groupEnd,info,log,timeStamp,profile,profileEnd,time,timeEnd,trace,warn".split(","),a;a=d.pop();){b[a]=b[a]||c}})((function(){try
{console.log();return window.console;}catch(err){return window.console={};}})());

var formatMoney = "$ \{\{amount\}\}";

function handleFirstTab(e) {
    if (e.keyCode === 9) { // tab
        document.body.classList.add('user-is-tabbing');
    }
}
window.addEventListener('keydown', handleFirstTab);
document.addEventListener("click", function(){
  document.body.classList.remove('user-is-tabbing');
});

jQuery(function($) {
  
  	setTimeout(function(){
      $('.content-wrapper').css('padding-top', $('#header').height());
      $(window).resize(function(){          
        $('.content-wrapper').css('padding-top', $('#header').height());
      });
	}, 200);

	$(window).scroll($.throttle(15, function(){
		
		if( $(this).scrollTop()>=100 ) {
			$('body').addClass('scroll');
			$('#header').css('margin-top',-$('#utility-bar').height())
		} else {
			$('body').removeClass('scroll');
			$('#header').css('margin-top',0)
		}

	}));	
	
	if(!isMobile.any) {
		$('body').addClass('isNotMobile'); 
	  }

    $(function(){
      // Video
      var video = document.getElementById("video");
      // Buttons
      var playButton = $('#play-pause');

      playButton.click(function(){
        if (video.paused == true) {
          // Play the video
          video.play();
          playButton.removeClass( "fa-play" ).addClass( "fa-pause" );
          // Update the button text to 'Pause'

        } else {
          // Pause the video
          video.pause();
          // Update the button text to 'Play'
          playButton.removeClass( "fa-pause" ).addClass( "fa-play" );
        }
      });
    });
  
  	$('.quantity').each(function(){
      	var wrapper = $(this);
		wrapper.find('.minus').click(function(){ 
          	try {
              wrapper.find('#quantity').get(0).stepDown();
            } catch(e) {
              var value = (parseInt(wrapper.find('#quantity').val())-1);
              wrapper.find('#quantity').val((value>=1 ? value : 1));
            }
        });
        wrapper.find('.plus').click(function(){
          try {
          	wrapper.find('#quantity').get(0).stepUp();
          } catch(e) {
          	wrapper.find('#quantity').val((parseInt(wrapper.find('#quantity').val())+1));
          }
        });  
  	});	

  	if($('#mini-cart').length > 0) {
    	initMiniCart();
  	}
  
  	
  		$('body').delegate('.add-to-cart-form', 'submit', function(){
            return validateAddCart($(this));
        });
  	
   
  
  $('#collection-grid .item-form, .section-featured .item-form').mouseenter(function(e){
    e.preventDefault();
    e.stopPropagation();
    if($(this).find('.second-img').size() > 0){
    	$(this).find('.image').height($(this).find('.first-img').height());
        $(this).find('.first-img').stop( true, true ).fadeOut();
        $(this).find('.second-img').stop( true, true ).fadeIn();
    }
    
  });
  $('#collection-grid .item-form, .section-featured .item-form').mouseleave(function(e){
    e.preventDefault();
    e.stopPropagation();
    if($(this).find('.second-img').size() > 0){
      $(this).find('.second-img').stop( true, true ).fadeOut();
      $(this).find('.first-img').stop( true, true ).fadeIn();
    }
  });

  $(document).on('click', '.search-toggle', function(){
    var element = $(this);
    element.parent().addClass('open');
    setTimeout(function(){
      element.parent().find('input.text').focus();
    },500);
    return false;
  });
  $(document).click(function(event){
    if(!$(event.target).closest('.search-form-wrap .form').length && $('.search-form-wrap').hasClass('open')) {
      $('.search-form-wrap').removeClass('open').find('label').focus();
      setTimeout(function(){
        $('.search-form-wrap').removeClass('toggleicon');
      },500);
    }
  });
  $(document).on('click', '.search-form-wrap .close', function(){
    $('.search-form-wrap').removeClass('open').find('label').focus();
    setTimeout(function(){
      $('.search-form-wrap').removeClass('toggleicon');
    },500);
    return false;
  });
  $(document).on('keydown', '.search-toggle:focus', function(e){
    if (e.which == 13) { //Enter
      $(this).click();
    }
  });

	
});

function validateAddCart(form) {
  if(form.find('input[name=id]').val()=='') {
        var allOptionsSelected;
      	if(form.find('.single-option-selector').length > 0) {
            allOptionsSelected = true;
            form.find('.single-option-selector').each(function(){
                if($(this).val()=="") {
                    allOptionsSelected = false;
                    return false;
                }
            });
        } else {
          	allOptionsSelected = false;
        }
      	
      	if(allOptionsSelected) {
          	var errorMsg = form.find('.validation-msg').text();
          	if(errorMsg) {
          		alert(errorMsg);
            } else {
            	alert("The selected variant is sold out.");
            }
        } else {
        	var labels = [];
            form.find('.options label').each(function(key, obj){
                labels.push($(obj).text().replace(':', '').trim());
            });
            alert("You must select a "+labels.join('/')+".");
        }
      	return false;
    }
  	return true;
}

function initMiniCart() {
	$('#view-cart-normal').click(function(e){
      e.stopPropagation();
      $('#mini-cart').slideToggle();
      return false;
    });
    $(document).click(function(event){
      if(!$(event.target).closest('#mini-cart').length && $(event.target).attr('id')!="loading-overlay" && $('#mini-cart').is(':visible')) {
        $("#mini-cart").slideUp();
      }
    });

    $('body').delegate('#mini-cart a.remove-from-cart', 'click', function(){
      var variantId = $(this).attr('href').replace('#', '');
      
      
      	location = '/cart/change/'+variantId+'?quantity=0';
      
      
      return false;
    });
}

/**
 * Page-specific call-backs
 * Called after dom has loaded.
 */
var RADIANCE = {

	common : {
		init: function(){
			$('html').removeClass('no-js').addClass('js');
			setupDropdownMenus();

			$('.nav-arrow', '#top-menu').each( function(){
				$(this).css('top', Math.ceil($(this).parent(2).height()/2) + 1);
			});

		}
	},

	templateIndex : {
		init: function(){

		}
	},

	templateProduct : {
		init: function(){
			//$('#product-actions').bind( 'submit', addToCart );
			$('#thumbs li:nth-child(5n+5)').addClass('last-in-row');
		}
	},

	templateCart : {
		init: function(){
          var checkGiftNote = function() {
              if($('#chk-is-gift').is(':checked')) {
                  $('#is-gift').val('Yes');
                	$('#gift-note').show();
              } else {
                  $('#is-gift').val('No');
                  $('#gift-note').hide();
                  $('#gift-note').find('textarea').val("");
              }
          }
          $('#chk-is-gift').click(function(){
            	checkGiftNote();
          });
          checkGiftNote();
		}
	}

}

/**
 * Fire function based upon attributes on the body tag.
 * This is the reason for "template" in layout/theme.liquid
 *
 * @see http://paulirish.com/2009/markup-based-unobtrusive-comprehensive-dom-ready-execution/
 */
var UTIL = {

	fire : function(func,funcname, args){
		var namespace = RADIANCE;
		funcname = (funcname === undefined) ? 'init' : funcname;
		if (func !== '' && namespace[func] && typeof namespace[func][funcname] == 'function'){
			namespace[func][funcname](args);
		}
	},

	loadEvents : function(){
		var bodyId = document.body.id;

		// hit up common first.
		UTIL.fire('common');

		// do all the classes too.
		$.each(document.body.className.split(/\s+/),function(i,classnm){
			UTIL.fire(classnm);
			UTIL.fire(classnm,bodyId);
		});
	}

};
$(document).ready(UTIL.loadEvents);

/**
 * Support for dropdown menus
 */
function setupDropdownMenus(){
  var config = {
    over: function () {
      $(this).addClass('active').find('.submenu:first').slideDown();
    }, 
    timeout: 400, 
    out: function () {
      $(this).removeClass('active').find('.submenu:first').slideUp();
    }
  };
  
  $('#header .has-dropdown').hoverIntent(config);
}

/**
 * Ajaxy add-to-cart
 */
function addToCart(form){
  	$('#add-cart-overlay').fadeIn();

	$.ajax({
		type: 'POST',
		url: '/cart/add.js',
		//async: false,
		data: form.serialize(),
		dataType: 'json',
		error: addToCartFail,
		success: addToCartSuccess,
		cache: false
	});
}

function addToCartSuccess (jqXHR, textStatus, errorThrown){
	$.ajax({
		type: 'GET',
		url: '/cart.js',
		async: false,
		cache: false,
		dataType: 'json',
		success: updateCartDesc
	});
	$('#add-cart-overlay').fadeOut();
  
  	$.fancybox(
    	$("<div />").append($("#item-added").clone().show()).html(), 
      	{
          overlayColor: '#fff', 
          onClosed: function(){
          	location = '/';
          }
        }
    );
}

function addToCartFail(jqXHR, textStatus, errorThrown){
	var response = $.parseJSON(jqXHR.responseText);
	$('#add-to-cart-msg').addClass('error').text(response.description).fadeIn('fast');
  	$('#add-cart-overlay').fadeOut();
}

function removeItemToCart(variantId){
  	$('#add-cart-overlay').fadeIn();

	$.ajax({
		type: 'POST',
		url: '/cart/change.js',
      	data: {
          id: variantId,
          quantity: 0
        },
		dataType: 'json',
      	error: function(){
      		$('#add-cart-overlay').fadeOut();
      	},
      	success: function(){
          	updateCartDesc();
      		$('#add-cart-overlay').fadeOut();
      	},
		cache: false
	});
}

function updateCartDesc(){  
  	$.ajax({
		type: 'GET',
		url: '/pages/mini-cart',
		async: false,
		cache: false,
      	success: function(data){
      		$('#mini-cart').remove();
          	$('li.cart-normal').append(data);
      	}
	});
}

window.SimplisticJS = function (){
	this.formatMoney = "$ \{\{amount\}\}";
	this.beforeTrapFocus = false;
	
	/**
	 * Traps the focus in a particular container
	 *
	 * @param {object} options - Options to be used
	 * @param {jQuery} options.$container - Container to trap focus within
	 * @param {jQuery} options.$elementToFocus - Element to be focused when focus leaves container
	 * @param {string} options.namespace - Namespace used for new focus event handler
	 */
	this.trapFocus = function(options) {
	  this.beforeTrapFocus = $(':focus');
	  var eventName = options.namespace
		? 'focusin.' + options.namespace
		: 'focusin';
  
	  if (!options.$elementToFocus) {
		options.$elementToFocus = options.$container;
	  }
  
	  options.$container.attr('tabindex', '-1');
	  options.$elementToFocus.focus();
  
	  $(document).on(eventName, function(evt) {
		if (
		  options.$container[0] !== evt.target &&
		  !options.$container.has(evt.target).length
		) {
		  options.$container.focus();
		}
	  });
	},
  
	/**
	 * Removes the trap of focus in a particular container
	 *
	 * @param {object} options - Options to be used
	 * @param {jQuery} options.$container - Container to trap focus within
	 * @param {string} options.namespace - Namespace used for new focus event handler
	 */
	this.removeTrapFocus = function(options) {
	  var eventName = options.namespace
		? 'focusin.' + options.namespace
		: 'focusin';
  
	  if (options.$container && options.$container.length) {
		options.$container.removeAttr('tabindex');
	  }
	  if(this.beforeTrapFocus) {
		  this.beforeTrapFocus.focus();
			this.beforeTrapFocus = false;
	  }
  
	  $(document).off(eventName);
	}
	
	this.handleize = function (str) {
	  //source https://gist.github.com/dlindenkreuz/a439ec4b939f0561d6d9
	  return str.toLowerCase().replace(/[^\w\u00C0-\u024f]+/g, "-").replace(/^-+|-+$/g, "");
	};
	
	this.reducedMotion = function() {
		return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
	};
  
	this.getQueryParam = function(name, url) {
	  if (!url) url = window.location.href;
	  name = name.replace(/[\[\]]/g, "\\$&");
	  var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
		  results = regex.exec(url);
	  if (!results) return null;
	  if (!results[2]) return '';
	  return decodeURIComponent(results[2].replace(/\+/g, " "));
	}
  
	this.randomstring = function(L){
	  var s= '';
	  var randomchar=function(){
		var n= Math.floor(Math.random()*62);
		if(n<10) return n; //1-10
		if(n<36) return String.fromCharCode(n+55); //A-Z
		return String.fromCharCode(n+61); //a-z
	  }
	  while(s.length< L) s+= randomchar();
	  return s;
	}
  
	this.validateEmail = function(email) {
	  var re = /^([\w-]+(?:\.[\w-]+)*)@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$/i;
	  return re.test(email);
	}
  
	this.openModal = function(content, css) {
	  modal = new tingle.modal({
		closeMethods: ['overlay', 'button', 'escape'],
		closeLabel: "Close",
		cssClass: [css],
		beforeOpen: function() {
		  $(".tingle-modal__close").appendTo(".tingle-modal-box__content");
		},
		beforeClose: function() {
		  $(".tingle-modal__close").prependTo(".tingle-modal");
		  return true;
		}
	  });
	  modal.setContent(content);
	  modal.open();
	}
  
	this.onImagesLoaded = function(images, callback){
	  var imagesLoaded = 0;
	  var loadFunction = function() {
		imagesLoaded++;
		if(imagesLoaded==images.length) {
		  callback();
		}
	  };
	  if(images.length>0) {
		images.each(function(){
		  var img = new Image();
		  img.onload = loadFunction;
		  img.onerror = loadFunction;
		  img.src = $(this).attr('src');
		});
	  } else {
		callback();
	  }
	};
	
	this.Media = new function() {
	  var media = this;
	  var mqS = window.matchMedia("(max-width: 600px)");
	  var mqM = window.matchMedia("(max-width: 900px)");
	  var mqO = window.matchMedia("(orientation: landscape)");
	  var tId = 0;
	  function updateMedia() {
		media.isLarge = !mqM.matches;
		media.isMediumUp = !mqS.matches;
		media.isMedium = mqM.matches && !mqS.matches;
		media.isMediumDown = mqM.matches;
		media.isSmall = mqS.matches;
		media.isLandscape = mqO.matches;
	  }
	  function handler() {
		clearTimeout(tId);
		tId = setTimeout(function() {
		  updateMedia();
		  $(window).trigger('mediaChange');
		}, 1);
	  }
	  updateMedia();
	  mqS.addListener(handler);
	  mqM.addListener(handler);
	  mqO.addListener(handler);
	  return this;
	}  
  };
  window.Simplistic = new SimplisticJS();